import {shallowEqual} from 'react-redux';
import type {CodeListId} from 'schemaDefinition/types';
import {useLocalization} from 'localization';
import {isLinkedRoleCodeListId} from 'schemaDefinition';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import {selectSettingsPreferredLocale} from 'services/settings';
import {useAppSelector} from 'store/hooks';
import {getLinkedRoleCodelist} from 'schemas/links/functions';
import type {CodeListMap} from '../types';
import {selectCodelistFromCache} from '../codelistSelectors';

export function useCodelistsLazy(
  codelistIds: (CodeListId | LinkedRoleCodeListId)[],
): CodeListMap | undefined {
  const localization = useLocalization();
  const language = useAppSelector(selectSettingsPreferredLocale);

  return useAppSelector(state => {
    let anyMissing = false;
    const map = codelistIds.reduce<CodeListMap>((acc, id) => {
      if (isLinkedRoleCodeListId(id)) {
        acc[id] = getLinkedRoleCodelist(id, localization);
        return acc;
      }

      const codelist = selectCodelistFromCache(id, language, state);
      if (!codelist) {
        anyMissing = true;
        return acc;
      }

      acc[id] = codelist;
      return acc;
    }, {});
    return anyMissing ? undefined : map;
  }, shallowEqual);
}
